var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.375 0C12.8242 0 14 1.17578 14 2.625V11.375C14 12.8242 12.8242 14 11.375 14H9.66146V8.57682H11.4753L11.7487 6.46224H9.66146V5.11328C9.66146 4.5026 9.82552 4.09245 10.7096 4.09245L11.8216 4.08333V2.19661C11.6302 2.16927 10.9648 2.11458 10.1992 2.11458C8.58594 2.11458 7.47396 3.09896 7.47396 4.90365V6.46224H5.65104V8.57682H7.47396V14H2.625C1.17578 14 0 12.8242 0 11.375V2.625C0 1.17578 1.17578 0 2.625 0H11.375Z",
    fill: "#8D8B97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.8606f4821904815d75942a730bdc6e5a.svg";
export { ForwardRef as ReactComponent };